// import React from 'react'
// import ReactDOM from 'react-dom/client'
// import { RouterProvider } from 'react-router-dom'
// import router from './App'

// import 'aos/dist/aos.css'
// import 'swiper/css'
// import 'swiper/css/navigation'
// import 'swiper/css/pagination'
// import 'swiper/css/effect-fade'
// import '@fortawesome/fontawesome-free/css/all.min.css'

// import './assets/css/variables.css'
// import './assets/css/main.css' 
// import './assets/css/home.css' 
// import './assets/css/navbar.css'
// import './assets/css/footer.css'   
// import './assets/css/inner-pages.css'
// import { HelmetProvider } from 'react-helmet-async'

// ReactDOM.createRoot(document.getElementById('root')).render(
//   <React.StrictMode>
//     <HelmetProvider>
//       <RouterProvider router={router} />
//     </HelmetProvider>
//   </React.StrictMode>
// )

import { ViteReactSSG } from 'vite-react-ssg'
import { routes } from './App'

import 'aos/dist/aos.css'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/effect-fade'
import '@fortawesome/fontawesome-free/css/all.min.css'

import './assets/css/variables.css'
import './assets/css/main.css'
import './assets/css/home.css'
import './assets/css/navbar.css'
import './assets/css/footer.css'
import './assets/css/inner-pages.css'

export const createRoot = ViteReactSSG({ routes })